export function normalizeGeneratedText(input: string): string {
  if (typeof input !== "string") return input as unknown as string;
  let out = input;
  for (let i = 0; i < 2; i += 1) {
    const next = out
      .replace(/\\r\\n/g, "\n")
      .replace(/\\n/g, "\n")
      .replace(/\\t/g, "\t")
      .replace(/\\"/g, "\"")
      .replace(/\\'/g, "'")
      .replace(/\\`/g, "`");
    if (next === out) break;
    out = next;
  }
  // Fix inline directives: LLMs sometimes emit ":::warning content" on a single line
  // with no closing :::. The block parser requires a newline after the opening.
  // Only transforms content that follows directly (not bracketed titles like [THE RISK],
  // which belong to properly-formatted blocks and should be left alone).
  out = out.replace(
    /(:::(?:clarification|info|warning|checklist))[ \t]+(?!\[)([^\n]+)/g,
    "$1\n$2\n:::",
  );
  // Close directive blocks that the LLM opened but never closed.
  // Split on each directive opening (zero-width lookahead), check each chunk for a
  // standalone closing :::, and append one if missing.
  {
    const parts = out.split(/(?=^:::(?:clarification|info|warning|checklist)(?:[ \t]|$))/m);
    out = parts
      .map((part, i) => {
        if (i === 0) return part; // text before the first directive
        const newlinePos = part.indexOf("\n");
        if (newlinePos === -1) return part + "\n:::\n"; // opener with no body at all
        const body = part.slice(newlinePos + 1);
        if (/^:::[ \t]*$/m.test(body)) return part; // already has closing :::
        return part.trimEnd() + "\n:::\n";
      })
      .join("");
  }
  return out;
}

export function normalizeGeneratedValue<T>(input: T): T {
  if (typeof input === "string") {
    return normalizeGeneratedText(input) as T;
  }
  if (Array.isArray(input)) {
    return input.map((entry) => normalizeGeneratedValue(entry)) as T;
  }
  if (input && typeof input === "object") {
    if (input instanceof Date) return input;
    const source = input as Record<string, unknown>;
    const out: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(source)) {
      out[key] = normalizeGeneratedValue(value);
    }
    return out as T;
  }
  return input;
}
